<template lang="pug">
v-main
  v-container(fluid)
    v-card.pa-3
      v-toolbar.elevation-0(color="white")
        v-toolbar-title {{ title }}
      v-divider
      v-card-text
        .d-flex
          div
            p.mt-1.subtitle__faq Download i-Memo guide

            v-btn.blue-custom.text-capitalize(
              depressed,
              :href="guideLink",
              download
            )
              img.mr-2(src="../assets/icon/download-v2.svg")
              | iMemo Guidance (English)


          //- div(class="ml-auto")
          //-     img(src="assets/faq-illustrator.jpg" class="img-faq")

        v-row.mt-1.pa-4
          p.mt-1.subtitle__faq Have questions? We're here to help.
          v-text-field.hidden-sm-and-down.col-12(
            outlined,
            prepend-inner-icon="search",
            placeholder="Search questions",
            v-model="keyword",
            hide-details,
            @keyup="getData"
          )

          v-expansion-panels.mt-5(accordion, flat)
            p(
              v-show="faqAdmin.length > 0"
              style="border-radius:8px;padding: 0.4rem;background-color: #E3E3E3; margin: 1rem; margin-left:0; color: #000; flex: 1; font-family: Roboto; font-size: 20px; font-weight: 500; line-height: 32px; letter-spacing: 0.0025em; text-align: left"
            ) FAQ Admin
            v-expansion-panel.elevation-0(
              v-for="(item, i) in faqAdmin",
              :key="i"
            )
              v-expansion-panel-header.custom-header.pl-4 {{ item.title }}
              v-expansion-panel-content.custom-subtitle.pl-4
                div(v-html="item.description")
            p(
              v-show="faqUser.length > 0"
              style="border-radius:8px;padding: 0.4rem;background-color: #E3E3E3; margin: 1rem; margin-left:0; color: #000; flex: 1; font-family: Roboto; font-size: 20px; font-weight: 500; line-height: 32px; letter-spacing: 0.0025em; text-align: left"
            ) FAQ User
            v-expansion-panel.elevation-0(
              v-for="(item, i) in faqUser",
              :key="i"
            )
              v-expansion-panel-header.custom-header.pl-4 {{ item.title }}
              v-expansion-panel-content.custom-subtitle.pl-4
                div(v-html="item.description")

            template(v-if="faqAdmin.length == 0 && faqUser.length == 0")
              .pa-15.text-center 
                |
                |
                img(src="../assets/icon/search.svg")
                .empty__title.mt-1 No Results Found
                .empty__subtitle Please try another search or contact us for more information
</template>

<script>
import axios from "axios";
export default {
  name: "FaqAdmin",
  props: {
    title: "",
  },
  data() {
    return {
      guideLink: process.env.MEMO_GUIDE_URL || "files/User-Guidance-Generic-iMemo-EN-v4.pdf",
      keyword: "",
      sortBy: "string",
      direction: -1,
      page: 1,
      perPage: 2000,
      faqAdmin: [],
      faqUser: [],
      total: null,
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    getLength() {
      return this.total / this.perPage;
    },
    getPerPage() {
      if (this.perPage == -1 || this.total < this.perPage) {
        return this.total;
      } else {
        return this.perPage;
      }
    },
  },
  methods: {
    getData() {
      let token = localStorage.getItem("token");
      const config = {
        method: "post",
        url: process.env.VUE_APP_API + `/faq/list`,
        headers: { Authorization: `Bearer ${token}` },
        data: {
          role: null,
          sortBy: "",
          direction: this.direction,
          page: this.page,
          perPage: this.perPage,
          keyword: this.keyword,
        },
      };
      axios(config)
        .then((res) => {
          const faqs = res.data.data;
          this.faqUser = []
          this.faqAdmin = []

          for (let i in faqs) {
            if (faqs[i].role == "general") this.faqUser.push(faqs[i]);
            else this.faqAdmin.push(faqs[i]);
          }

          // this.faq = [...admins, ...users];
          this.total = res.data.total;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-content__wrap ol li {
  color: #626262;
  margin-bottom: 1em;
}
</style>

<style>
button.custom__padding-btn {
  padding: 1.4rem 2rem !important;
}

.v-toolbar__content {
  box-shadow: none;
}

.v-expansion-panel-header.custom-header {
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  border-bottom: 1px solid #dddddd;
}

.color-blue {
  color: #1976d2;
}

.color-red {
  color: #f44336;
}

.color-green {
  color: #4caf50;
}

.color-black {
  color: #121212;
}

.color-orange {
  color: #ff9800;
}

.blue-custom {
  background: #1976d2 !important;
  color: #fff !important;
  font-size: 14px;
  padding: 1.5rem 1rem !important;
}

.blue-custom img {
  color: #fff !important;
}

.img-faq {
  height: 130px;
  width: auto;
}

.custom-subtitle {
  color: #626262;
  padding-top: 1rem;
}

.custom-pagination .v-pagination__navigation {
  box-shadow: none !important;
}

.custom-pagination .v-pagination .v-pagination__navigation:hover {
  background: #e0e0e0 !important;
}

.subtitle__faq {
  font-size: 16px;
  color: #000000;
}
</style>